import React from 'react';

import clsx from 'clsx';
import { ElementType, forwardRef } from 'react';
import { PolymorphicComponentPropWithRef, PolymorphicRef } from '../../../types/polymorphic-ref';

export type ContainerVariant = 'lg' | 'md';

export type ContainerProps<C extends ElementType> = PolymorphicComponentPropWithRef<
    C,
    {
        variant?: ContainerVariant;
    }
>;

export const Container = forwardRef(function Container<C extends ElementType = 'div'>(
    { as, children, className, variant = 'lg', ...props }: ContainerProps<C>,
    ref: PolymorphicRef<C>
) {
    const Component = as || 'div';

    return (
        <Component
            ref={ref}
            className={clsx('mx-auto w-full px-4 md:px-8 lg:px-16', className, {
                'max-w-[1728px]': variant === 'lg',
                'max-w-[1456px]': variant === 'md',
            })}
            {...props}
        >
            {children}
        </Component>
    );
});
